import WieldySidebarSection from "../WieldySidebarSection";
import React, {useEffect, useState, Fragment, useContext} from "react";
import '../ChildSidebar/SidebarChildren.scss';
import ContactSidebarEntry from "./ContactSidebarEntry";
import SpinnerDiv from "root/Components/SpinnerDiv";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {getMyContacts} from "root/DataFunctions/MessageDataFns";
import {useSetRecoilState} from "recoil";
import {selectedContact} from "root/recoil/selectedContact";
import {useGlobalContext} from "root/contexts/GlobalContext";

const SidebarContacts = (props) =>
{
    const [contacts, setContacts] = useState({loading: true, data: []});
    const setSelectedContact = useSetRecoilState(selectedContact);

    const { userType } = useGlobalContext() ;

    const getContacts = () => {
        getMyContacts( userType, 'active',( response) =>
        {
            const contacts = getDataFromResponse(response);

            setContacts({loading: false, data: contacts});
            const first = contacts.length > 0 ? contacts[0] : {};
            setSelectedContact({record: first});
        });
    }

    useEffect(() => {
        getContacts();
    }, []);

    const contactList = () =>
    {
        return contacts.data.map((contact, index) => {
            return (
                <ContactSidebarEntry keyName={contact.user_id} contact={contact} key={contact.user_id}/>
            )
        });
    }

    if (contacts.loading === true)
    {
        return <SpinnerDiv/>
    }
    else
    {
        return (
            <Fragment>
                <ul className="dt-side-nav">
                    <WieldySidebarSection title='Contacts' key='contacts'>
                        <div className="child-sidebar-container">
                            {contactList()}
                        </div>
                    </WieldySidebarSection>
                </ul>
            </Fragment>
        )
    }
}

export default SidebarContacts;
